import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment } from "react";
import Carousel from "../../components/Carousel";
import MarqueeList from "../../components/marquee/marqueeList";
import GameTypeSelector from "../../components/v3Layout/GameTypeSelector/GameTypeSelector";
import SubListSelector from "../../components/v3Layout/SubListSelector/SubListSelector";
import JackpotWrapper from "../../components/v3Layout/Jackpot/JackpotWrapper";
import PlatformSelector from "../../components/v3Layout/PlatformSelector/PlatformSelector";
import MobileSearchV2 from "../Search/mobile-search_v2";
import LiveGameSelector from "../../components/v3Layout/GameSelector/LiveGameSelector";
import GameSelector from "../../components/v3Layout/GameSelector/GameSelector";
import Seo from "./seo";
import MarqueeListV2 from "../../components/marquee/marqueeList_v2";

const TableV3 = ({ gameMainTypeFromProps }) => {
  return (
    <Fragment>
      <Seo />
      <Box as="section" px="common-y">
        <MarqueeListV2 />
      </Box>

      <Box
      // mt={{
      //   md: "0px",
      //   base: "10px",
      // }}
      >
        <MobileSearchV2 listHidden />
      </Box>
      <Flex>
        <Box pb="home-space" pl="common-y" pr="5px">
          <GameTypeSelector gameMainTypeFromProps={gameMainTypeFromProps} />
        </Box>

        {/* <Box py="home-space" px="common-y">
        <LeaderBoard />
      </Box> */}
        {/* <Box px="common-y">
        <SubListSelector />
      </Box> */}
        <Box
          overflowY="scroll"
          flex={1}
          // h={{
          //   base: "80vh",
          //   md: "auto",
          // }}
        >
          <Box pb="home-space" px="common-y">
            <PlatformSelector gameMainTypeFromProps={gameMainTypeFromProps} />
          </Box>
          <Box mt="home-space" px="common-y">
            <JackpotWrapper />
          </Box>

          <Box py="home-space" px="common-y">
            {/* <SubListSelector /> */}
            <GameSelector
              gameMainTypeFromProps={gameMainTypeFromProps}
              subListSelector
            />
          </Box>
        </Box>
      </Flex>
    </Fragment>
  );
};

export default TableV3;
